// extracted by mini-css-extract-plugin
module.exports = {"DeleteModal":"DeleteModal_DeleteModal__2JrPj","SubmitBtn":"DeleteModal_SubmitBtn__dDdoQ"};